import { IPublicClientApplication } from '@azure/msal-browser';
import { ReviewerData } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  deleteNominationReviewer,
  getAssignedNominationReviewer,
  getAvailableNominationReviewers,
  upsertNominationReviewer,
} from './index';
import { deleteCountryNominationReviewer } from './delete-country-nomination-reviewer';
import { getAssignedCountryNominationReviewer } from './get-assigned-country-nomination-reviewer';
import { upsertCountryNominationReviewer } from './upsert-country-nomination-reviewer';

export const createNominationsReviewersApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getAvailableNominationReviewers: (instance: IPublicClientApplication, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAvailableNominationReviewers(fetchContext, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAvailableNominationReviewers', isInFlight);
    },
  ),
  getAssignedNominationReviewer: (instance: IPublicClientApplication, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAssignedNominationReviewer(fetchContext, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAvailableNominationReviewers', isInFlight);
    },
  ),
  getAssignedCountryNominationReviewer: (instance: IPublicClientApplication, programId: number, countryId: number, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAssignedCountryNominationReviewer(fetchContext, programId, countryId, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAvailableNominationReviewers', isInFlight);
    },
  ),
  upsertNominationReviewer: (instance: IPublicClientApplication, nominationId: number, reviewerData: ReviewerData) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => upsertNominationReviewer(fetchContext, nominationId, reviewerData, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAvailableNominationReviewers', isInFlight);
    },
  ),
  upsertCountryNominationReviewer: (instance: IPublicClientApplication, programId: number, countryId: number, nominationId: number, reviewerData: ReviewerData) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => upsertCountryNominationReviewer(fetchContext, programId, countryId, nominationId, reviewerData, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAvailableNominationReviewers', isInFlight);
    },
  ),
  deleteNominationReviewer: (instance: IPublicClientApplication, nominationId: number, nominationReviewerId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteNominationReviewer(fetchContext, nominationId, nominationReviewerId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAvailableNominationReviewers', isInFlight);
    },
  ),
  deleteCountryNominationReviewer: (instance: IPublicClientApplication, programId: number, countryId: number, nominationId: number, nominationReviewerId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteCountryNominationReviewer(fetchContext, programId, countryId, nominationId, nominationReviewerId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAvailableNominationReviewers', isInFlight);
    },
  ),
});
